import Navbar from '../../components/home/Navbar';
import Hero from '../../components/home/Hero';
import Features from '../../components/home/Features';
import HowItWorks from '../../components/home/HowItWorks';
import Testimonials from '../../components/home/Testimonials';
import Pricing from '../../components/home/Pricing';
import FinalCTA from '../../components/home/FinalCTA';
import Footer from '../../components/home/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-blue-500/30">
      <Navbar />

      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <Testimonials />
        <Pricing />
        <FinalCTA />
      </main>

      {/* <Footer /> */}
    </div>
  );
}
